module.exports = __webpack_public_path__ + "img/billplz.d28900c7.png";